'use strict';

window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

$(document).ready(function () {
    // processInclude(require('./util/utils'));
    // processInclude(require('./util/videos'));
    processInclude(require('./experience/carousel-init'));
    processInclude(require('./experience/countdown-timer'));
    processInclude(require('./experience/recommendation-activity'));
    processInclude(require('./experience/dataCloudCarousel'));
    processInclude(require('./experience/dataCloudSignupForm.client'));
    processInclude(require('./experience/ci360-init'));
});

require('slick-carousel');
